export enum TierLevel {
  TIER_ONE = 'TIER_ONE',
  TIER_TWO = 'TIER_TWO',
  TIER_THREE = 'TIER_THREE',
  UNPROVEN = 'UNPROVEN',
  TIER_FOUR = 'TIER_FOUR',
  TIER_FIVE = 'TIER_FIVE',
}

export type WorkerTier = {
  tierLevel: TierLevel
  minimumReliabilityScore?: number
  minimumBusinessApprovalScore?: number
  minimumNumberCompletions?: number
  minimumNumberUniqueBusinesses?: number
  minimumNumberFavorites?: number
}

export const REFERRAL_ELIGIBLE_TIERS: string[] = [
  TierLevel.TIER_ONE,
  TierLevel.TIER_TWO,
  TierLevel.TIER_THREE,
]

export const minimumTierMap = {
  TIER_ONE: TierLevel.TIER_ONE,
  TIER_TWO: TierLevel.TIER_TWO,
  TIER_THREE: TierLevel.TIER_THREE,
  TIER_FOUR: TierLevel.TIER_FOUR,
  TIER_FIVE: TierLevel.TIER_FIVE,
  UNPROVEN: TierLevel.UNPROVEN,
}

export const tierLevelMenuItems: Array<{
  value: TierLevel
  label: string
}> = [
  { value: TierLevel.TIER_ONE, label: 'Tier 1' },
  { value: TierLevel.TIER_TWO, label: 'Tier 2' },
  { value: TierLevel.TIER_THREE, label: 'Tier 3' },
  { value: TierLevel.UNPROVEN, label: 'Unproven' },
  { value: TierLevel.TIER_FOUR, label: 'Tier 4' },
  { value: TierLevel.TIER_FIVE, label: 'Tier 5' },
] as const
